const Dashboard = () => {
    return (
        <>
            <h2>Dashboard Page</h2>
            <p>
                이곳은 대시보드입니다. 여기에 핵심 정보나 통계 등이 표시됩니다.
            </p>
        </>
    );
};

export default Dashboard;
